import { Component, ElementRef, Inject, LOCALE_ID, OnInit, ViewChild, NgZone, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PrivacyPolicyComponent } from '../../common/privacy-policy/privacy-policy.component';
import { environment } from 'src/environments/environment';
import { Organization } from 'src/app/classes/organization';
import { Router } from '@angular/router';
import { PublicSettingsService } from 'src/app/services/public-settings.service';
import Locales from 'src/app/constants/locales';
import { LanguageSelectorComponent } from '../../common/language-selector/language-selector.component';
import { Capacitor } from '@capacitor/core';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { TncComponent } from '../../common/tnc/tnc.component';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss'],
})
export class SigninComponent implements OnInit, AfterViewInit {
  @ViewChild('organizationSelect') organizationSelect!: ElementRef
  @ViewChild('emailInput') emailInput!: ElementRef
  @ViewChild('passwordInput') passwordInput!: ElementRef
  
  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
    organization: new FormControl<number | null>(null),
  })

  existingUserFound = false
  environment = environment
  organization = new Organization()
  organizations: Organization[] = []
  fa = fa
  locales = Locales
  locale = $localize.locale
  socialAuthSubscription!: any
  platform = Capacitor.getPlatform()
  showPassword = false
  showOverlay = false

  constructor(
    private titleService: Title,
    private authService: AuthService,
    private settingsService: PublicSettingsService,
    private modalService: NgbModal,
    private router: Router,
    private ngZone: NgZone,
    @Inject(LOCALE_ID) public activeLocale: string) { }

  async ngOnInit() {
    this.titleService.setTitle($localize`Sign in / Sign up`)

    window.scrollTo(0, 0)

    if (Capacitor.getPlatform() == "web") {
      this.showOverlay = true

      FirebaseAuthentication.getRedirectResult().then(result => {
        this.showOverlay = false

        if (result.credential && result.credential.providerId == 'google.com') {
          this.authService.signinGoogle({ ...result.user, referral_code: localStorage.getItem('customer_referral_code') })
        }

        else if (result.credential && result.credential.providerId == 'apple.com') {
          this.authService.signinApple({ ...result.user, referral_code: localStorage.getItem('customer_referral_code') })
        }
      })
    }
  }

  ngAfterViewInit() {
    if(this.platform == 'web') {
      this.emailInput.nativeElement.focus()
    }
  }

  languageSelector() {
    const modal = this.modalService.open(LanguageSelectorComponent, { centered: true, size: 'md' })
  }

  signin() {
    this.showOverlay = true
    
    this.authService.signin(this.loginForm.value).subscribe({
      next: (res: any) => {
        this.showOverlay = false
      },
      error: (error: any) => {
        this.showOverlay = false
      }
    })
  }

  existingUser() {
    this.showOverlay = true
    
    this.authService.existingUser(this.loginForm.controls.email.value as string).subscribe({
      next: (res: any) => {
        if (res.existing == true) {
          this.showOverlay = false
          this.existingUserFound = true
          
          setTimeout(() => {
            this.passwordInput.nativeElement.focus()
          }, 100)
        }

        else {          
          this.authService.signin(this.loginForm.value).subscribe({
            next: () => {
              this.showOverlay = false
            },
            error: (error: any) => {
              this.showOverlay = false
            }
          })
        }
      },
      error: (error: any) => {
        this.showOverlay = false
        this.existingUserFound = false
        console.error('existingUser error', error.error.message)
      }
    });
  }

  privacyPolicy() {
    this.modalService.open(PrivacyPolicyComponent, { centered: true, size: 'lg' })
  }

  tnc() {
    const modal = this.modalService.open(TncComponent, { centered: true, size: 'lg' })

    modal.componentInstance.showAccept = false
  }

  async appleSignup() {
    try {
      this.showOverlay = true

      const result = await FirebaseAuthentication.signInWithApple({ mode: 'redirect' });

      this.showOverlay = false

      this.authService.signinApple({ ...result.user, referral_code: localStorage.getItem('customer_referral_code') })
    } catch (error) {
      this.showOverlay = false
      alert($localize`Signin with Apple not available: ` + error);
    }
  }

  async googleSignup() {
    try {
      this.showOverlay = true

      const result = await FirebaseAuthentication.signInWithGoogle({ mode: 'redirect' });

      this.showOverlay = false

      this.authService.signinGoogle({ ...result.user, referral_code: localStorage.getItem('customer_referral_code') })
    } catch (error) {
      this.showOverlay = false
      alert($localize`Signin with Google not available: ` + error);
    }
  }
}
